import { ErrorMessage, Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useImmer } from 'use-immer'
import FormikControl from '../../../components/FormikControl'
import Loader from '../../../components/Loader'
import ReactSelect from '../../../components/ReactSelect'
import TextError from '../../../components/TextError'
import CustomToast from '../../../components/Toast/CustomToast'
import {
  arrangeNamesBySequence,
  changeHandler,
  decodeId,
  encodeId,
  prepareNotificationData,
  showToast
} from '../../../lib/AllGlobalFunction'
import {
  isAllowPriceVariant,
  isAllowWarehouseManagement,
  isInventoryModel,
  productStatus
} from '../../../lib/AllStaticVariables'
import axiosProvider from '../../../lib/AxiosProvider'
import { _productImg_ } from '../../../lib/ImagePath'
import { _SwalDelete, _exception } from '../../../lib/exceptionMessage'
import { setPageTitle } from '../../redux/slice/pageTitleSlice'
import NotWarehouseAndPrice from '../NotWarehouseAndPrice'
import NotWarehousePrice from '../NotWarehousePrice'
import WarehouseAndPrice from '../WarehouseAndPrice'
import WarehouseNotPrice from '../WarehouseNotPrice'
import { fetchEditData, validateForm } from '../productUtils/helperFunctions'
import { productInitVal, productValidationSchema } from '../productUtils/init'
import { prepareExistingProductPayload } from '../productUtils/prepareProductPayload'
import {
  checkAndSetSKUCode,
  handleSellerChangeInExisting
} from '../productUtils/productFunctions'

const ExistingProductForm = () => {
  const navigate = useNavigate()
  const encodedId = useParams()
  const dispatch = useDispatch()
  const id = encodedId?.id ? decodeId(encodedId?.id) : null
  const [initialValues, setInitialValues] = useState(productInitVal)
  const [loading, setLoading] = useState(false)
  const location = useLocation()
  const { userInfo, sellerDetails } = useSelector((state) => state?.user)
  const [calculation, setCalculation] = useState()
  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })
  const [allState, setAllState] = useImmer({
    sellerDetails: [],
    brand: [],
    category: [],
    color: [],
    sizeType: [],
    warehouseDetails: [],
    hsnCode: [],
    weight: []
  })

  const handleSubmit = async (values) => {
    if (!values?.productPrices?.length) {
      showToast(toast, setToast, {
        code: 204,
        message:
          'Unexpected error while saving the data. Please try again later.'
      })
      return
    }

    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'POST',
        endpoint: 'AddInExistingProduct/addExistingProduct',
        data: prepareExistingProductPayload(values),
        location: location?.pathname,
        userId: userInfo?.userId
      })
      setLoading(false)

      if (response?.data?.code === 200) {
        const productID = response?.data?.data

        const notificationData = prepareNotificationData({
          imageUrl: values?.productImage[0]?.image,
          reciverId: userInfo?.userId,
          userId: userInfo?.userId,
          userType: userInfo?.userType,
          notificationTitle: `Product name: ${arrangeNamesBySequence(
            values?.productName
          )} added successfully`,
          notificationDescription: `Product added by ${userInfo?.fullName}`,
          url: `/manage-product?id=${encodeId(productID)}`,
          notifcationsof: 'Product'
        })

        await axiosProvider({
          endpoint: 'Notification',
          method: 'POST',
          data: notificationData
        })

        setToast({
          show: true,
          text: response?.data?.message,
          variation: response?.data?.code !== 200 ? 'error' : 'success'
        })

        setTimeout(() => {
          navigate('/manage-product')
          setToast({ ...toast, show: false })
        }, 2000)
      } else {
        showToast(toast, setToast, response)
      }
    } catch (error) {
      setLoading(false)
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  useEffect(() => {
    dispatch(setPageTitle(`Add Existing Product`))
  }, [])

  useEffect(() => {
    if (id) {
      fetchEditData({
        setAllState,
        allState,
        setLoading,
        id,
        initialValues,
        setInitialValues,
        setCalculation,
        calculation,
        toast,
        setToast,
        navigate,
        isAddInExisting: true,
        userInfo
      })
    } else {
      Swal.fire({
        title: 'Error!',
        text: 'Product data not found.',
        icon: _SwalDelete.icon,
        showCancelButton: false,
        confirmButtonColor: _SwalDelete.confirmButtonColor,
        cancelButtonColor: _SwalDelete.cancelButtonColor,
        confirmButtonText: 'OK',
        cancelButtonText: _SwalDelete.cancelButtonText
      }).then((result) => {
        if (result.isConfirmed) {
          // here i want to navigate to add in existing
          navigate('/manage-product')
        }
      })
    }
  }, [id])

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={productValidationSchema(initialValues, allState)}
    >
      {({
        values,
        setFieldValue,
        resetForm,
        setTouched,
        setErrors,
        errors,
        touched
      }) => (
        <Form className='product_form existing_pro_form'>
          <div className='card'>
            <div className='card-body'>
              <Row className='justify-content-between align-items-center'>
                <Col md={3}>
                  <h5 className='mb-1 head_h3'>Product Details</h5>
                </Col>
                <Col className='text-end'>
                  <div className='d-flex align-items-center justify-content-end gap-3'>
                    <label className='form-label fw-600 mb-0'>
                      Is Product Live
                    </label>
                    <div className='switch'>
                      <input
                        type='radio'
                        value={true}
                        id='yes'
                        checked={values?.live}
                        name='choice'
                        onChange={(e) => {
                          if (e?.target?.checked) setFieldValue('live', true)
                        }}
                      />
                      <label htmlFor='yes'>Yes</label>
                      <input
                        type='radio'
                        value={false}
                        id='no'
                        name='choice'
                        checked={!values?.live}
                        onChange={(e) => {
                          if (e?.target?.checked) setFieldValue('live', false)
                        }}
                      />
                      <label htmlFor='no'>No</label>
                      <span className='switchFilter'></span>
                    </div>
                  </div>
                </Col>
              </Row>
              <div className='row hr-main-row mb-3 align-items-center'>
                <div className='col-2 hr-image-section'>
                  <div className='hr-image'>
                    {values?.productImage?.length > 0 && (
                      <img
                        alt='...'
                        src={`${process.env.REACT_APP_IMG_URL}${_productImg_}${values?.productImage[0]?.image}`}
                      />
                    )}
                  </div>
                </div>
                <div className='col hr-content-section'>
                  <Row className='gy-1'>
                    <Col md={12}>
                      <h5 className='bold'>
                        {arrangeNamesBySequence(values?.productName ?? [])}
                      </h5>
                    </Col>

                    {values?.sellerProducts && (
                      <div className='d-flex gap-2'>
                        <span className='bold'>Seller : </span>
                        <span>{values?.sellerProducts?.sellerName}</span>
                      </div>
                    )}

                    {values?.sellerProducts?.brandName && (
                      <div className='d-flex gap-2'>
                        <span className='bold'>Brand : </span>
                        <span>{values?.sellerProducts?.brandName}</span>
                      </div>
                    )}

                    {values?.companySKUCode && (
                      <div className='d-flex gap-2'>
                        <span className='bold'>Company SKU : </span>
                        <span>{values?.companySKUCode}</span>
                      </div>
                    )}

                    {values?.productColorMapping?.length > 0 && (
                      <div className='d-flex gap-2'>
                        <span className='bold'>Color : </span>
                        <span>
                          {values?.productColorMapping
                            ?.map((obj) => obj.colorName)
                            .join(', ')}
                        </span>{' '}
                      </div>
                    )}

                    {values?.sizeName && (
                      <div className='d-flex gap-2'>
                        {values?.sizeName && (
                          <div>
                            <span className='bold'>Size Type : </span>
                            <span>{values?.sizeName}</span>
                          </div>
                        )}
                      </div>
                    )}

                    {values?.categoryPathName && (
                      <div className='d-flex gap-2'>
                        <span className='bold'>Category Paths : </span>
                        <span>{values?.categoryPathName}</span>
                      </div>
                    )}
                  </Row>
                </div>
              </div>

              <div className='row border-top pt-3'>
                {!isInventoryModel && (
                  <div className='col-md-4'>
                    <div className='input-file-wrapper mb-3'>
                      <label className='form-label required'>
                        Select Seller
                      </label>
                      <ReactSelect
                        id='sellerID'
                        name='sellerID'
                        isRequired
                        errors={errors?.sellerID}
                        touched={touched?.sellerID ?? false}
                        placeholder='Select Seller'
                        value={
                          values?.sellerID && {
                            value: values?.sellerID,
                            label: values?.sellerName
                          }
                        }
                        options={
                          allState?.sellerDetails?.length
                            ? allState?.sellerDetails
                                ?.filter(
                                  (item) =>
                                    !values?.existingSellerIds?.includes(
                                      item?.userId
                                    )
                                )
                                ?.map(
                                  ({
                                    userId,
                                    displayName,
                                    shipmentBy,
                                    shipmentChargesPaidByName
                                  }) => ({
                                    value: userId,
                                    label: displayName,
                                    shipmentBy,
                                    shipmentPaidBy: shipmentChargesPaidByName
                                  })
                                )
                            : []
                        }
                        onChange={(e) => {
                          setFieldValue('sellerID', e?.value)
                          setFieldValue('sellerName', e?.displayName)
                          setFieldValue('shipmentBy', e?.shipmentBy)
                          setFieldValue('shipmentPaidBy', e?.shipmentPaidBy)

                          handleSellerChangeInExisting({
                            sellerDetails: {
                              sellerID: e?.value,
                              sellerName: e?.label,
                              shipmentBy: e?.shipmentBy,
                              shipmentPaidBy: e?.shipmentPaidBy
                            },
                            values,
                            resetForm,
                            allState,
                            setAllState,
                            navigate
                          })
                        }}
                      />
                    </div>
                  </div>
                )}

                <div className='col-md-4'>
                  <div className='input-file-wrapper'>
                    <label className='form-label fw-600 required'>Status</label>
                    <ReactSelect
                      id='status'
                      name='status'
                      isRequired
                      errors={errors?.status}
                      touched={touched?.status ?? false}
                      placeholder='Product Status'
                      options={productStatus}
                      value={
                        values?.status && {
                          value: values?.status,
                          label: values?.status
                        }
                      }
                      onChange={(e) => {
                        setFieldValue('status', e?.value ?? '')
                      }}
                    />
                  </div>
                </div>

                <div className='col-md-4'>
                  <div className='input-file-wrapper mb-3 position-relative'>
                    <FormikControl
                      id='sellerSKU'
                      control='input'
                      type='text'
                      isRequired
                      label='Seller SKU code'
                      name='sellerSKU'
                      placeholder='Seller SKU code'
                      onBlur={async () => {
                        checkAndSetSKUCode(false, values, resetForm)
                      }}
                      onChange={(e) => {
                        changeHandler(
                          'sellerSKU',
                          e?.target?.value,
                          setFieldValue
                        )
                      }}
                    />
                    {values?.isSellerSKUAvailable && (
                      <i className='m-icon m-icon--tick-icon kl-verify-icon'></i>
                    )}
                    {values?.sellerSKU && (
                      <ErrorMessage
                        name='isSellerSKUAvailable'
                        component={TextError}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {values?.sellerID && (
            <>
              {!isAllowWarehouseManagement && !isAllowPriceVariant && (
                <NotWarehouseAndPrice
                  allState={allState}
                  values={values}
                  setFieldValue={setFieldValue}
                  calculation={calculation}
                  setCalculation={setCalculation}
                  resetForm={resetForm}
                  errors={errors}
                  touched={touched}
                />
              )}

              {isAllowWarehouseManagement && !isAllowPriceVariant && (
                <WarehouseNotPrice
                  allState={allState}
                  values={values}
                  setFieldValue={setFieldValue}
                  calculation={calculation}
                  setCalculation={setCalculation}
                  resetForm={resetForm}
                  errors={errors}
                  touched={touched}
                />
              )}

              {!isAllowWarehouseManagement && isAllowPriceVariant && (
                <NotWarehousePrice
                  allState={allState}
                  values={values}
                  setFieldValue={setFieldValue}
                  calculation={calculation}
                  setCalculation={setCalculation}
                  resetForm={resetForm}
                  errors={errors}
                  touched={touched}
                />
              )}

              {isAllowWarehouseManagement && isAllowPriceVariant && (
                <WarehouseAndPrice
                  allState={allState}
                  values={values}
                  setFieldValue={setFieldValue}
                  calculation={calculation}
                  setCalculation={setCalculation}
                  resetForm={resetForm}
                  errors={errors}
                  touched={touched}
                />
              )}

              <Button
                variant='primary'
                className='d-flex align-items-center gap-2 justify-content-center fw-semibold'
                onClick={() => {
                  validateForm({
                    values,
                    setErrors,
                    setTouched,
                    resetForm,
                    errors,
                    toast,
                    setToast,
                    handleSubmit,
                    allState
                  })
                }}
              >
                Save product
              </Button>
            </>
          )}

          {loading && <Loader />}

          {toast?.show && (
            <CustomToast text={toast?.text} variation={toast?.variation} />
          )}
        </Form>
      )}
    </Formik>
  )
}

export default ExistingProductForm
